import React from "react";
import DotButton from "components/presenters/button/DotButton";
import CameraBtnImg from "images/todolist_camera_btn-42x42.png";
import CheckBtnImg from "images/todolist_check_btn-42x42.png";
import FailBtnImg from "images/todolist_fail_btn-42x42.png";
import checkIcon from "images/icon/check_icon-58x42.png";
import closeIcon from "images/icon/close_icon-46x46.png";
import camaraIcon from "images/icon/camara_white_icon-43×35.png";
import { format } from "date-fns";
import { formatDate } from "utils/utils";
import {
  TaskItemWrapper,
  ItemLeft,
  ItemLeftLink,
  ItemRight,
  TaskInfoWrapper,
  TaskInfoLinkWrapper,
  TaskTitle,
  ItemLeftWhiteBlock,
  ItemLeftBlock,
  ItemLeftActiveBlock,
  ItemLeftCompleteImgBlock,
  ItemLeftFailImgBlock,
  ItemLeftCamaraImgBlock,
  ItemLeftImg,
} from "./style";
import { Link } from "react-router-dom";

export default function TodoListItem({
  task,
  style,
  onClickUploadBtn,
  onOptionBtnClick,
  linkPath,
  relation,
  onError,
  disableEditTask = false,
}) {
  let leftBtn = [];
  let formattedTime = null;

  if (task) {
    if (Array.isArray(task["proof"]) && task["proof"].length > 0) {
      if (["self", "friend"].includes(relation)) {
        leftBtn.push(
          <Link
            key={`task-item-btn-${task["no"]}`}
            to={
              relation === "self"
                ? `/task/${task["no"]}`
                : `/task/${task["no"]}`
            }
          >
            <ItemLeftWhiteBlock>
              <ItemLeftCompleteImgBlock>
                <ItemLeftImg src={checkIcon} />
              </ItemLeftCompleteImgBlock>
            </ItemLeftWhiteBlock>
          </Link>
        );
      } else if (relation === "other") {
        leftBtn.push(
          <ItemLeft
            key={`task-item-btn-${task["no"]}`}
            onClick={(e) => {
              if (onError) {
                onError({
                  error: "INVALID_RELATION_STATUS",
                  error_detail: "FRIEND_STATUS_REQUIRED",
                });
              }
            }}
          >
            <ItemLeftWhiteBlock>
              <ItemLeftCompleteImgBlock>
                <ItemLeftImg src={checkIcon} />
              </ItemLeftCompleteImgBlock>
            </ItemLeftWhiteBlock>
          </ItemLeft>
        );
      }
    } else if (formatDate() > formatDate(task["task_date"])) {
      leftBtn.push(
        <ItemLeft>
          <ItemLeftWhiteBlock>
            <ItemLeftFailImgBlock>
              <ItemLeftImg src={closeIcon} />
            </ItemLeftFailImgBlock>
          </ItemLeftWhiteBlock>
        </ItemLeft>
      );
    } else if (formatDate() < formatDate(task["task_date"])) {
      leftBtn.push(
        <ItemLeft
          key={`task-item-btn-${task["no"]}`}
          onClick={(e) => {
            if (onError && relation === "self") {
              onError({
                error: "INVALID_TO_SUBMIT",
                error_detail: "SUBMITION_TIME_NOT_STARTED",
              });
            }
          }}
        >
          <ItemLeftBlock>
            <ItemLeftCamaraImgBlock>
              <ItemLeftImg src={camaraIcon} />
            </ItemLeftCamaraImgBlock>
          </ItemLeftBlock>
        </ItemLeft>
      );
    } else {
      if (relation === "self") {
        leftBtn.push(
          <ItemLeft
            key={`task-item-btn-${task["no"]}`}
            onClick={onClickUploadBtn}
          >
            <ItemLeftActiveBlock>
              <ItemLeftCamaraImgBlock>
                <ItemLeftImg src={camaraIcon} />
              </ItemLeftCamaraImgBlock>
            </ItemLeftActiveBlock>
          </ItemLeft>
        );
      } else {
        leftBtn.push(
          <ItemLeft key={`task-item-btn-${task["no"]}`}>
            <ItemLeftActiveBlock>
              <ItemLeftCamaraImgBlock>
                <ItemLeftImg src={camaraIcon} />
              </ItemLeftCamaraImgBlock>
            </ItemLeftActiveBlock>
          </ItemLeft>
        );
      }
    }

    if (task["time"]) {
      const [hour, min, sec] = task["time"].split(":");
      formattedTime = format(new Date().setHours(hour, min, sec), "h:mmaaa");
    }
  }
  return (
    <>
      {task ? (
        <TaskItemWrapper style={style}>
          {leftBtn}
          <ItemRight>
            {Array.isArray(task["proof"]) && task["proof"].length > 0 ? (
              <TaskInfoLinkWrapper to={`/task/${task["no"]}`}>
                <TaskTitle>{task["title"]}</TaskTitle>
              </TaskInfoLinkWrapper>
            ) : (
              <TaskInfoWrapper
                onClick={relation === "self" ? onClickUploadBtn : null}
              >
                <TaskTitle>{task["title"]}</TaskTitle>
              </TaskInfoWrapper>
            )}
          </ItemRight>
          {![null, undefined].includes(onOptionBtnClick) &&
            !disableEditTask && <DotButton onClick={onOptionBtnClick} />}
        </TaskItemWrapper>
      ) : null}
    </>
  );
}
